import type { FC } from "react";

import {
	isVocalalGuideActivatedSelector,
	musicEffectsSelector,
	vocalEffectsSelector,
} from "@redux/featureFlags/selector";
import { activatedVolumeSelector } from "@redux/session/selectors";
import { withBamLayoutSelector } from "@redux/user/selectors";
import { useSelector } from "react-redux";
import { ReactComponent as GameIcon } from "assets/game.svg";
import { ReactComponent as MikeIcon } from "assets/mike-icon-bam.svg";

import { isVocalGuideActivated } from "services/helpers/featureToggle";

import AudioOptionButton from "./AudioOptionButton";
import { AudioOptions } from "./VoiceControl.style";
import VolumeComponent from "./Volume";
import { Tonality } from "../Tonality/Tonality";
import VoiceEffects from "../VoiceEffects/VoiceEffects";
import { AudioOptionButtonState } from "./AudioOptionButton/AudioOptionButton.const";
import { GameControlAirConsoleModal } from "components/b2b/Games/GameControleModal";
import { sendMultiScreenEventToTv } from "services/helpers/multiScreen";
import { PlayerEvent } from "shared-types/player-event";
import { useSetCurrentGame } from "@redux/game";
import { useGames } from "hooks/useGames";

interface IVoiceControl {
	vocalGuideButtonState: AudioOptionButtonState;
	handleToggleVocalGuideClick: () => void;
}

const VoiceControl: FC<IVoiceControl> = ({
	vocalGuideButtonState,
	handleToggleVocalGuideClick,
}) => {
	const withBamLayout = useSelector(withBamLayoutSelector);
	const isVocalEffectActivated = useSelector(vocalEffectsSelector);
	const isMusicEffectActivated = useSelector(musicEffectsSelector);
	const isVolumeActivated = useSelector(activatedVolumeSelector);
	const isVocalGuideFeatureActivated = useSelector(
		isVocalalGuideActivatedSelector,
	);

	const {
		airConsole: { isActivated: isAirConsoleActivated, game: AIRCONSOLE },
	} = useGames();
	const { setCurrentGame } = useSetCurrentGame();

	return (
		<AudioOptions>
			{isVolumeActivated && <VolumeComponent />}

			{isMusicEffectActivated && <Tonality />}
			{isVocalEffectActivated && <VoiceEffects />}
			{isAirConsoleActivated && withBamLayout && (
				<>
					<AudioOptionButton
						Icon={GameIcon}
						translationId="bam-discovery.games"
						buttonState={AudioOptionButtonState.INACTIVE}
						onClick={() => {
							sendMultiScreenEventToTv(
								PlayerEvent.START_GAME,
								JSON.stringify(AIRCONSOLE),
							);
							setCurrentGame(AIRCONSOLE);
						}}
					/>
					<GameControlAirConsoleModal />
				</>
			)}

			{isVocalGuideFeatureActivated && isVocalGuideActivated() && (
				<AudioOptionButton
					Icon={MikeIcon}
					translationId="control-bar.vocal-guide"
					buttonState={vocalGuideButtonState}
					onClick={handleToggleVocalGuideClick}
				/>
			)}
		</AudioOptions>
	);
};

export default VoiceControl;
